<div class="select-route-container">
  <button mat-raised-button color="primary" routerLink="/routes">
    Select Route
  </button>

  <div *ngIf="selectedRoute" class="selected-route">
    <mat-icon>check_circle</mat-icon>
    Selected Route: <strong>{{ selectedRoute.route }}</strong>
  </div>

  <!-- Use routerLink with query parameters -->
  <button mat-raised-button
          color="accent"
          routerLink="/customers" 
          [disabled]="!selectedRoute">
    Continue
  </button>
</div>
